import React from "react";
import GenericCrudPage from "../../components/shared/GenericCrudPage";
import { adminGetVendors, adminCreateVendor, adminUpdateVendor } from "../../api/business";

export default function VendorsPage() {
  return (
    <GenericCrudPage
      title="Vendors"
      queryKey="admin-vendors"
      listFn={adminGetVendors}
      createFn={adminCreateVendor}
      updateFn={adminUpdateVendor}
      emptyItem={{ name: "", logo: "", website_url: "", is_active: true }}
      columns={[
        { key: "name", label: "Name" },
        { key: "website_url", label: "Website" },
        { key: "is_active", label: "Active", render: (r) => (r.is_active ? "Yes" : "No") },
      ]}
      formFields={[
        { name: "name", label: "Name", required: true },
        { name: "logo", label: "Logo", type: "file" },
        { name: "website_url", label: "Website URL" },
        { name: "is_active", label: "Active", type: "switch" },
      ]}
    />
  );
}